import styled from 'styled-components';

interface IProps {
  isSelected: boolean;
  isHasBottomBorder: boolean;
}

export const LanguageItemStyled = styled.div<IProps>`
  padding-right: 12px;
  border-bottom: ${({ isHasBottomBorder }) => (isHasBottomBorder ? '1px solid #000' : '1px solid #ccc')};
  background-color: ${({ isSelected }) => (isSelected ? '#eaf4ff' : 'rgba(255, 255, 255, 0.8)')};
  .item-content {
    padding: 12px 0 12px 12px;
    margin-right: 12px;
  }
`;
